module.exports = __webpack_public_path__ + "img/ipod.6ef9737e.png";